import axios from "@/utils/request";
export const jobsApi = (data: any) => {
  return axios({
    path: "/publicJobs/list",
    method: "POST",
    data
  })
}
